import React from "react";
import { createNativeStackNavigator } from "@react-navigation/native-stack";
import { Platform } from "react-native";
import { createStackNavigator } from "@react-navigation/stack";
import { NetworkStackParamList } from "../types";
import NetworkingScreen from "@navigation/screens/MidLevel/NetworkingScreen/NetworkingScreen";
import SearchCompScreen from "@navigation/screens/MidLevel/NetworkingScreen/SearchCompScreen";
import ProfilesScreen from "@navigation/screens/MidLevel/NetworkingScreen/ProfilesScreen";
import Meet from "@navigation/screens/MidLevel/NetworkingScreen/Meet";
import NetworkingMenu from "@navigation/screens/MidLevel/NetworkingScreen/NetworkingMenu";
import { themeSelector } from "@reduxLocal/selectors/themeSelector";
import MeetingList from "@navigation/screens/MidLevel/NetworkingScreen/MeetingList";

const NetworkingStack = Platform.select({default: createNativeStackNavigator<NetworkStackParamList>(), web: createStackNavigator<NetworkStackParamList>() })

export const NetworkNavigator = () => {
  const theme = themeSelector();
  return (
    <NetworkingStack.Navigator
      initialRouteName="NetworkingMenu"
      screenOptions={{
        headerShown: false, cardStyle: {
          backgroundColor: theme ? "white" : "black",
        }
      }}>
      {/* Add your screens here */}
      <NetworkingStack.Screen name="NetworkingMenu" options={{ freezeOnBlur: true }} component={ Platform.OS != 'web' ? NetworkingMenu : NetworkingScreen} />
      <NetworkingStack.Screen name="Map" options={{ freezeOnBlur: true }} component={NetworkingScreen} />
      <NetworkingStack.Screen name="Profiles" options={{ freezeOnBlur: true }} component={ProfilesScreen} />
      <NetworkingStack.Screen name="Meet" options={{ freezeOnBlur: true }} component={Meet} />
      <NetworkingStack.Screen name="MeetingList" options={{ freezeOnBlur: true }} component={MeetingList} />
      <NetworkingStack.Screen name="Search" component={SearchCompScreen} />
    </NetworkingStack.Navigator>
  )
}

export default NetworkingStack;